import script from "./privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy.vue?vue&type=script&setup=true&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=58b77690&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b77690"]])

export default __exports__